import { Button, Row } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useRouteMatch } from '@fs/zion-router'
import { Arrow } from '@fs/zion-icon'
import { deleteLastPathElement } from '../../../../util/UrlUtil'

export default function ToolsButtons({ children, datsJobActions }) {
  const { t } = useTranslation()
  const match = useRouteMatch()

  return (
    <Row>
      <Button to={deleteLastPathElement(match.url)} iconDirection="backward" Icon={Arrow}>
        {t('dats.goBackToJobs', 'Go Back to Jobs')}
      </Button>
      <Button onClick={() => datsJobActions.notifyRefreshObservers()}>{t('dats.Refresh', 'Refresh')}</Button>
      {children}
    </Row>
  )
}
